import React, { useCallback } from 'react'
import { useCanvas } from '../../context/canvas'
import { copyToClipboard } from '../../lib/clipboard'

const SignalDebugMenuItem = ({ signal, closeMenu }) => {
  const { canvas } = useCanvas()

  const onClick = useCallback(() => {
    const data = {
      canvas,
      signal
    }
    copyToClipboard(data, true)
    closeMenu()
  }, [closeMenu, canvas, signal])

  return (
    <button onClick={onClick} className="px-4 py-2 text-left focus:outline-none">
      <div className="text-color-151d49 text-size-16px font-weight-500">Copy Debug Data</div>
    </button>
  )
}

export default SignalDebugMenuItem
